import { render, staticRenderFns } from "./SparePartTransfer.vue?vue&type=template&id=0fca2b20"
import script from "./SparePartTransfer.vue?vue&type=script&lang=ts"
export * from "./SparePartTransfer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports